/******Realisations******/

/***GENERAL***/
import { useState, useEffect } from "react";
import { RegexThis } from "./00-Appendix.js";

/*PAGE*/
export default function Realisations(data) {
  //Setting Page title and content according tos elected section / url
  let pageType = "";
  let pageTitle = "";

  if (window.location.href.indexOf("enseignement-numerique") != -1) {
    pageType = "num";
    pageTitle = "Enseignement numérique";
  } else if (window.location.href.indexOf("campus-augmente") != -1) {
    pageType = "campus";
    pageTitle = "Campus augmenté";
  } else if (
    window.location.href.indexOf("simplification-administrative") != -1
  ) {
    pageType = "admin";
    pageTitle = "Simplification administrative";
  }

  //Removing card anim once played for hovering animation instead
  setTimeout(() => {
    let thoses = document.getElementsByClassName("cardLink");

    for (let i in thoses) {
      let thisOne = thoses[i].classList;
      if (thisOne != undefined) {
        thisOne.add("noAnimCards");
      }
    }
  }, "2500");

  //Dynamic display of cards according to selected section / url
  function displayCards(R, i) {
    if (R.type == pageType) {
      return (
        <a
          className="cardLink"
          key={R.name + i}
          //Temporarily disable link
      /*    href={"/realisation" + "/" + RegexThis(R.name)}*/
        >
          <div className="cardImg">
            <img
              fetchpriority="high"
              src={"/img/real/" + R.img + ".webp"}
              alt={"Image d'illustration pour :" + " " + R.name}
            />
          </div>
          <p className="cardName">{R.name}</p>
          <p className="cardDesc">{R.desc}</p>
        </a>
      );
    }
  }

  /*DOM*/
  return (
    <div className="homepage realisations">
      <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div>
      <h1>{pageTitle}</h1>
      <div className="realWrapper">
        {data.data.map((R, i) => displayCards(R, i))}
      </div>
    </div>
  );
}
